import React from 'react';
import { ExternalLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

function PrivacyGerman() {
  return (
    <div className="privacy-policy">
      <h1>Datenschutzrichtlinie</h1>

      <p>
        Diese Datenschutzerklärung bezüglich der Verarbeitung personenbezogener Daten durch{' '}
        <strong>VivianLab </strong>soll Ihnen helfen zu verstehen, welche personenbezogenen Daten
        wir erheben, warum wir sie erheben und wie wir sie verwenden. Bitte nehmen Sie sich die Zeit,
        diese Datenschutzerklärung sorgfältig durchzulesen. Wir möchten, dass Sie genau wissen, wie
        wir Ihre Daten verwenden und auf welche Weise Sie Ihre Rechte ausüben können. Diese
        Datenschutzerklärung spiegelt auch unsere Verpflichtungen gemäß dem EU-Gesetz über künstliche
        Intelligenz (AI Act) in Bezug auf Transparenz, Rechenschaftspflicht und den
        verantwortungsvollen Einsatz von KI-Systemen wider.
      </p>

      <p>
        <strong>Geltungsbereich.</strong> Diese Datenschutzerklärung wurde in Übereinstimmung mit der
        Datenschutz-Grundverordnung (DSGVO) und den geltenden Datenschutzgesetzen in Griechenland und
        im Europäischen Wirtschaftsraum (EWR) erstellt. Unsere Plattform und unsere Dienste richten
        sich in erster Linie an Nutzer mit Wohnsitz im EWR. Wenn Sie von einem Land außerhalb des
        EWR auf die Plattform zugreifen oder diese nutzen, tun Sie dies auf eigene Initiative und sind
        allein dafür verantwortlich, sicherzustellen, dass dieser Zugriff und diese Nutzung den
        Gesetzen Ihres Wohnsitzlandes entsprechen. Soweit erforderlich, berücksichtigen wir auch
        geltende Gesetze außerhalb des EWR, einschließlich Datenschutzgesetze der Vereinigten Staaten
        wie den California Consumer Privacy Act (CCPA/CPRA) und andere Vorschriften auf
        Bundesstaatenebene. Wenn Sie von außerhalb des EWR auf die Plattform zugreifen oder diese
        nutzen, erkennen Sie an, dass Ihre personenbezogenen Daten gemäß den EU-Standards verarbeitet
        werden können, ergänzt durch zusätzliche Schutzmaßnahmen, sofern dies nach geltendem lokalem
        Recht erforderlich ist.
      </p>

      <p>
        Soweit die Gesetze Ihres Landes strengere Verpflichtungen auferlegen als diese
        Datenschutzerklärung, gelten Ihre lokalen Gesetze nur für Ihre Nutzung der Plattform,
        während die Verarbeitung personenbezogener Daten durch VivianLab weiterhin ausschließlich der
        DSGVO unterliegt.
      </p>

      <p>
        Diese Datenschutzerklärung gilt für Ihre personenbezogenen Daten, wenn Sie unsere
        Webplattform <strong>www.vivianlab.com</strong> (die „Plattform“ oder „die Plattform“)
        besuchen und nutzen oder unsere auf der Plattform verfügbaren Dienste nutzen und/oder unsere
        mobilen/technologischen Anwendungen (Apps) nutzen. Sie gilt nicht für andere
        Anwendungen/Websites/Online-Shops und/oder Dienste, die nicht in unserem Besitz sind oder von
        uns kontrolliert werden.
      </p>

      <p>
        Wenn Sie unsere auf der Plattform verfügbaren Dienste nutzen, bestätigen Sie, dass Sie diese
        Datenschutzerklärung bezüglich der Verarbeitung personenbezogener Daten durch „VivianLab“
        gelesen und verstanden haben.
      </p>

      <h2>1. Wer sind wir?</h2>
      <p>
        Das Unternehmen, das Ihnen über die Plattform Dienstleistungen anbietet, ist{' '}
        <strong>VIVIANLAB LTD</strong>, mit Sitz und Geschäftsadresse: 1612 SOFIA BUL. TSAR BORIS III
        № 81 ET.1, AP.1, VAT BG207933919, E-Mail{' '}
        <a href="mailto:info@vivianlab.com">info@vivianlab.com</a> (im Folgenden als „wir“, „das
        Unternehmen“ oder „die Firma“ bezeichnet).
      </p>

      <p>
        <strong>Unsere Rolle – Verantwortlicher und Auftragsverarbeiter:</strong>
      </p>
      <p>
        Je nach Situation handelt VIVIANLAB LTD gemäß der Datenschutz-Grundverordnung (DSGVO) in
        unterschiedlicher Funktion:
      </p>
      <ul>
        <li>
          Wir sind der <strong>Verantwortliche</strong>, wenn Sie ein Konto auf der Plattform
          registrieren, unseren Newsletter abonnieren oder unsere Dienste für eigene Zwecke nutzen (z.&nbsp;B.
          den KI-Assistenten). In diesem Fall legen wir die Zwecke und Mittel der Verarbeitung
          Ihrer personenbezogenen Daten fest.
        </li>
        <li>
          Wir sind der <strong>Auftragsverarbeiter</strong>, wenn Sie unsere Plattform nutzen, um mit
          Dritten (z.&nbsp;B. „Spezialisten“) zu interagieren oder Dienstleistungen von diesen zu erhalten.
          In diesem Zusammenhang ist der „Spezialist“ der Verantwortliche für Ihre Daten, und wir
          verarbeiten diese in seinem Auftrag und auf seine Anweisung hin gemäß einer zwischen uns und
          dem Spezialisten geschlossenen{' '}
          <ExternalLink href="/de/data-processing-addendum">
            Datenverarbeitungsvereinbarung (DPA)
          </ExternalLink>
          .
        </li>
      </ul>

      <h2>2. Kontaktdaten für Datenschutzanliegen</h2>
      <p>
        Bei Fragen zu dieser Richtlinie oder zur Verarbeitung Ihrer personenbezogenen Daten können
        Sie sich unter <a href="mailto:info@vivianlab.com">info@vivianlab.com</a> an uns wenden
        oder direkt unseren Datenschutzbeauftragten (DSB) unter{' '}
        <a href="mailto:experience@vivianlab.com">experience@vivianlab.com</a> kontaktieren.
      </p>

      <p>
        Da der Schutz personenbezogener Daten für unser Unternehmen von größter Bedeutung ist, legt
        dieses Dokument die Verpflichtungen sowie die Art und Weise der Nutzung, Weitergabe und des
        Schutzes der uns übermittelten Daten fest und beschreibt, wie wir etwaige Probleme durch
        gegenseitigen Austausch lösen können.
      </p>

      <h3>2.1 Definitionen</h3>

      <p>
        <strong>Datenschutzrecht</strong> bezeichnet alle Rechtsvorschriften im Zusammenhang mit der
        Verarbeitung personenbezogener Daten, dem Datenschutz und der Sicherheit, einschließlich,
        aber nicht beschränkt auf die Verordnung (EU) 2016/679 „zum Schutz natürlicher Personen bei
        der Verarbeitung personenbezogener Daten, zum freien Datenverkehr und zur Aufhebung der
        Richtlinie 95/46/EG (Datenschutz-Grundverordnung)“ („DSGVO“), die Richtlinie 2002/58/EG „über
        den Schutz der Privatsphäre in der elektronischen Kommunikation“, in der in die griechische
        Rechtsordnung übernommenen, gültigen und angewandten Fassung sowie in ihrer jeweils gültigen
        Fassung, oder andere anwendbare oder die oben genannten ersetzende internationale oder
        nationale Gesetze oder Vorschriften zum Schutz personenbezogener Daten sowie einschlägige
        Verordnungen, Anweisungen oder Leitlinien zuständiger Verwaltungsbehörden, wie beispielsweise
        der griechischen Datenschutzbehörde.
      </p>

      <p>
        <strong>„Verantwortlicher“</strong>, <strong>„Auftragsverarbeiter“</strong>,{' '}
        <strong>„betroffene Person“</strong>, <strong>„personenbezogene Daten“</strong> und{' '}
        <strong>„Verarbeitung“</strong> haben die ihnen in den geltenden Datenschutzgesetzen
        zugewiesene Bedeutung.
      </p>

      <p>
        <strong>„personenbezogene Daten“</strong> bezeichnet alle Informationen, die sich auf eine
        identifizierte oder identifizierbare natürliche Person („betroffene Person“) beziehen. Als
        identifizierbar wird eine natürliche Person angesehen, die direkt oder indirekt,
        insbesondere mittels Zuordnung zu einer Kennung wie beispielsweise:
      </p>
      <ul>
        <li>Name, E-Mail-Adresse, Telefonnummer</li>
        <li>Identifikationsnummer</li>
        <li>Standortdaten (z.&nbsp;B. Land oder Stadt)</li>
        <li>Online-Identifikator (z.&nbsp;B. IP-Adresse, Cookie-ID)</li>
        <li>Zahlungsinformationen (z.&nbsp;B. Transaktionsdaten)</li>
        <li>
          Oder ein oder mehrere Merkmale, die für die physische, physiologische, genetische,
          psychische, wirtschaftliche, kulturelle oder soziale Identität dieser natürlichen Person
          spezifisch sind.
        </li>
      </ul>

      <p>
        <strong>„Besondere Kategorien personenbezogener Daten“</strong> (auch als „sensible Daten“
        bezeichnet) sind eine Untergruppe personenbezogener Daten, die Informationen wie die
        rassische oder ethnische Herkunft, politische Meinungen, biometrische Daten (zum Zwecke der
        eindeutigen Identifizierung einer Person) und Gesundheitsdaten (wie Aufzeichnungen über
        Symptome, das Stadium der Menopause oder Daten von Wearables) offenlegen. Wir verarbeiten
        diese Daten nur unter Einhaltung strengerer Vorschriften, in der Regel auf der Grundlage
        Ihrer ausdrücklichen Einwilligung.
      </p>

      <p>
        <strong>Dienste:</strong> Die auf unserer Plattform genannten und zur Nutzung angebotenen
        Dienste.
      </p>

      <p>
        <strong>Websites:</strong> „www.vivianlab.com“ ist die Website unseres Unternehmens. Das
        Unternehmen betreibt eine elektronische Plattform, die als professionelles Online-Verzeichnis
        dient und Endnutzer („Nutzer“) mit Fachleuten aus dem Gesundheitswesen („Fachleute“), wie
        Ärzten und Gesundheitsexperten, zusammenbringt, um Beratung, Rat und Unterstützung in
        Gesundheitsfragen anzubieten. Darüber hinaus bietet die Plattform innovative digitale Dienste
        an, darunter unter anderem einen KI-Assistenten (KI-Tracker) zur Erfassung von
        Gesundheitssymptomen und Stimmungslagen, der personalisierte, KI-gestützte Anleitungen
        bereitstellt, sowie Funktionen zur Terminverwaltung (auch durch Integrationen von
        Drittanbietern). Die Plattform kann zudem die Übermittlung von Bestellungen aus kooperierenden
        Geschäften mit gesundheitsbezogenem Angebot erleichtern und diese Bestellungen über ein
        Netzwerk unabhängiger Vertriebspartner weiterleiten.
      </p>

      <p>
        <strong>Verarbeitung personenbezogener Daten</strong> ist jede mit oder ohne Hilfe
        automatisierter Verfahren ausgeführte Handlung oder jede Reihe von Handlungen in Bezug auf
        personenbezogene Daten oder Datensätze, wie das Erheben, Erfassen, Organisieren, Ordnen,
        Speichern, Anpassen oder Verändern, das Abrufen, Abfragen, Verwenden, Offenlegen durch
        Übermittlung, Verbreitung oder jede andere Form der Bereitstellung, das Verknüpfen oder
        Zusammenführen, das Einschränken, Löschen oder Vernichten.
      </p>

      <p>
        <strong>Nutzung der Plattform durch Minderjährige.</strong> Unsere Plattform und unsere
        Dienste richten sich an Erwachsene und sind nicht für Kinder unter 16 Jahren bestimmt. Wir
        erheben wissentlich keine personenbezogenen Daten von Kindern unter 16 Jahren. Sollten wir
        feststellen, dass wir personenbezogene Daten von einem Kind unter 16 Jahren ohne
        entsprechende elterliche Einwilligung erhoben haben, werden wir Maßnahmen ergreifen, um
        diese Informationen zu löschen. Wenn Sie der Meinung sind, dass ein Kind uns
        personenbezogene Daten zur Verfügung gestellt hat, kontaktieren Sie uns bitte unter{' '}
        <a href="mailto:info@vivianlab.com">info@vivianlab.com</a>.
      </p>

      <p>
        <strong>
          Keine automatisierten Entscheidungen mit rechtlichen oder ähnlich schwerwiegenden
          Auswirkungen.
        </strong>{' '}
        Wir verwenden Ihre personenbezogenen Daten nicht, um Entscheidungen zu treffen, die
        ausschließlich auf einer automatisierten Verarbeitung (einschließlich Profiling) beruhen und
        rechtliche Auswirkungen auf Sie haben oder Sie in ähnlicher Weise erheblich beeinträchtigen im
        Sinne von Artikel 22 DSGVO. Unser KI-Assistent liefert lediglich allgemeine Informationen
        und Vorschläge zum Thema Wellness und trifft keine verbindlichen Entscheidungen über Ihren
        Zugang zu Dienstleistungen, Versicherungsschutz, Beschäftigung, Krediten oder ähnlichen
        Angelegenheiten.
      </p>

      <p>
        <strong>Einsatz künstlicher Intelligenz (KI-Systeme)</strong>{' '}
        Unsere Plattform umfasst Funktionen, die auf künstlicher Intelligenz (KI) basieren, darunter
        einen KI-Assistenten für Wellness-Beratung, Symptomverfolgung und personalisierte Inhalte.
        Diese Systeme arbeiten mit Modellen des maschinellen Lernens und generieren Ergebnisse auf der
        Grundlage von Datenmustern und nicht anhand deterministischer Logik.
      </p>

      <p>
        <strong>Transparenz der KI-Interaktion</strong>{' '}
        Wenn Sie KI-gestützte Funktionen nutzen, interagieren Sie mit einem automatisierten System
        und nicht mit einem Menschen. Wir informieren die Nutzer innerhalb der Benutzeroberfläche
        deutlich, wann KI-generierte Inhalte bereitgestellt werden, in Übereinstimmung mit den
        geltenden EU-Vorschriften.
      </p>

      <h2>3. Zweck der Verarbeitung und Dauer</h2>
      <p>
        Wir verarbeiten Ihre personenbezogenen Daten zum Zweck der Bereitstellung der auf unserer
        Plattform beschriebenen Dienste. Unsere Rolle bei der Verarbeitung Ihrer Daten hängt von der
        jeweiligen Situation und dem von Ihnen genutzten Dienst ab:
      </p>
      <ul>
        <li>
          <strong>Wenn wir als Verantwortlicher auftreten:</strong> Bei Aktivitäten wie der Verwaltung
          Ihres Benutzerkontos, dem Versand von Marketingmitteilungen (Newsletter) oder der
          Bereitstellung unseres KI-Assistenten (AI Tracker) treten wir als Verantwortlicher auf. In
          diesen Fällen legen wir die Zwecke und Rechtsgrundlagen (wie z.&nbsp;B. die Erfüllung eines
          Vertrags, Ihre Einwilligung oder ein berechtigtes Interesse) für die Verarbeitung
          selbstständig fest.
        </li>
        <li>
          <strong>Wenn wir als Auftragsverarbeiter auftreten:</strong> Wenn Sie die Plattform nutzen,
          um mit Dritten (z.&nbsp;B. „Spezialisten“) zu interagieren oder Dienstleistungen von diesen zu erhalten,
          fungiert dieser „Spezialist“ (der Ihnen die Beratung erbringt) in der Regel als
          Verantwortlicher für die Daten im Zusammenhang mit dieser Dienstleistung. In dieser
          Situation fungiert das Unternehmen als Auftragsverarbeiter und erhebt und verarbeitet Ihre
          Daten (z.&nbsp;B. Terminangaben, Notizen) ausschließlich im Auftrag und auf ausdrückliche
          Anweisung des jeweiligen „Spezialisten“ (des Verantwortlichen). In diesem Fall liegt die
          Verantwortung für die Festlegung der Rechtsgrundlage (z.&nbsp;B. Ihre Einwilligung zur
          Verarbeitung von Gesundheitsdaten) beim Verantwortlichen (d.&nbsp;h. dem „Spezialisten“).
        </li>
      </ul>

      <p>
        Wir verwenden personenbezogene Daten nur, wenn dies zur Erfüllung unserer Verpflichtungen gemäß
        den Allgemeinen Geschäftsbedingungen und den geltenden Rechtsvorschriften unbedingt erforderlich
        ist.
      </p>

      <p>
        Die Verarbeitungsvorgänge werden so lange fortgesetzt, wie es für die Erbringung der
        Dienstleistungen und die Erfüllung unserer gesetzlichen Verpflichtungen erforderlich ist, wie
        in Abschnitt 14 („Wie lange speichern wir Ihre Daten?“) dieser Richtlinie dargelegt.
      </p>

      <p>
        Unabhängig von unserer Rolle (Verantwortlicher oder Auftragsverarbeiter) behandeln wir alle
        personenbezogenen Daten als vertrauliche geschützte Informationen und wenden strenge technische
        und organisatorische Maßnahmen zu deren Schutz an.
      </p>

      <h2>4. Ist die Bereitstellung Ihrer personenbezogenen Daten verpflichtend?</h2>
      <p>
        Die Bereitstellung der Daten an das Unternehmen kann zur Erreichung der in dieser
        Datenschutzerklärung genannten Zwecke erforderlich oder freiwillig sein.
      </p>
      <p>
        Ob die Bereitstellung der Daten obligatorisch oder freiwillig ist, wird durch ein Sternchen (*)
        neben den obligatorischen personenbezogenen Daten gekennzeichnet.
      </p>
      <p>
        Wenn Sie sich weigern, die auf der Plattform als obligatorisch gekennzeichneten Informationen
        bereitzustellen, ist es unmöglich, den Hauptzweck zu erreichen, für den die spezifischen Daten
        erhoben werden, und es kann beispielsweise dazu führen, dass das Unternehmen den Transportdienst
        nicht erbringen oder andere auf seinen Websites verfügbare Dienste nicht bereitstellen kann.
      </p>
      <p>
        Die Bereitstellung zusätzlicher Daten an das Unternehmen, die über die als obligatorisch
        gekennzeichneten Daten hinausgehen, ist freiwillig und hat keine Auswirkungen auf die
        Hauptzwecke der Datenerhebung, da ihre Bereitstellung ausschließlich der Optimierung der
        Qualität der von uns erbrachten Dienstleistungen dient.
      </p>

      <h2>5. Welche personenbezogenen Daten erheben wir über Sie?</h2>
      <p>
        Wir achten darauf, nur Ihre absolut notwendigen personenbezogenen Daten zu erheben, die für den
        vorgesehenen Zweck angemessen und eindeutig sind. Diese Daten umfassen Folgendes:
      </p>
      <ul>
        <li>
          <strong>
            Daten, die Sie uns bei Ihrer Registrierung und der Erstellung eines Benutzerkontos zur
            Verfügung stellen:
          </strong>{' '}
          Im Rahmen unseres Registrierungsprozesses erheben wir Pflichtangaben wie Vor- und Nachname,
          E-Mail-Adresse, Geburtsdatum, Land und Stadt. Wir verarbeiten außerdem Ihr
          Passwort/Anmeldepasswort (das verschlüsselt gespeichert wird). Optional können Sie weitere
          Daten angeben, wie z.&nbsp;B. Ihre Postanschrift oder Telefonnummer.
        </li>
        <li>
          <strong>
            Daten und Informationen, die Sie uns im Rahmen unserer Transaktionen und Kommunikation zur
            Verfügung stellen:
          </strong>{' '}
          Dazu gehören Dienstleistungen, Optionen, Synergien und die Kommunikation zwischen uns (über
          die Plattform, Partner, Telefon, E-Mail oder auf andere Weise). Beispielsweise erfassen wir
          Notizen aus unseren Gesprächen mit Ihnen (Kommunikationsdaten), Details zu Ihren
          Beschwerden oder Kommentaren, Angaben zu den von Ihnen ausgewählten Dienstleistungen,
          wiederkehrende Präferenzen usw.
        </li>
        <li>
          <strong>Daten im Zusammenhang mit der Zahlungsabwicklung:</strong> Informationen, die zur
          Abwicklung von Zahlungen und zum Abschluss von Transaktionen erforderlich sind, wie
          E-Mail-Adresse, Telefonnummer, Angaben zur Zahlungsmethode (z.&nbsp;B. Name des
          Karteninhabers, Kartendaten) und Rechnungsadresse.
        </li>
        <li>
          <strong>Daten, die Sie uns bei der Anmeldung zu unserem Newsletter zur Verfügung stellen:</strong>{' '}
          Wie Name und E-Mail-Adresse, die auf der Grundlage Ihrer Einwilligung erhoben werden.
        </li>
        <li>
          <strong>Daten für die Integration mit Diensten von Drittanbietern:</strong> Wenn Sie sich
          dafür entscheiden, Ihr Konto zu verknüpfen, erhalten wir möglicherweise Zugriff auf Daten aus
          Google Kalender (z.&nbsp;B. zum Erstellen, Aktualisieren und Löschen von Terminen), um deren
          Verwaltung zu erleichtern. Dies geschieht nur nach Ihrer ausdrücklichen Einwilligung (siehe
          Abschnitt „Integration mit Google Meet und Google Kalender“).
        </li>
        <li>
          <strong>Daten zu Präferenzen und Plattformnutzung:</strong> Daten zu den Optionen und
          Diensten, die Sie im Allgemeinen bevorzugen, mit dem Ziel, Ihnen Dienste zu empfehlen, die für
          Sie von Interesse sind. Informationen, die durch die Verwendung von Cookies in Ihrem Browser
          erfasst werden (weitere Informationen finden Sie in unserer{' '}
          <ExternalLink href="/de/cookie-policy">Cookie-Richtlinie</ExternalLink>). Technische
          Informationen über Ihre Internetverbindungen und Ihren Browser sowie das Land und die
          Vorwahl, in dem sich Ihr Computer befindet, die während Ihres Besuchs angezeigten Webseiten,
          die von Ihnen angeklickten Werbeanzeigen und alle von Ihnen eingegebenen Suchbegriffe.
        </li>
        <li>
          <strong>Daten aus sozialen Medien:</strong> Ihr Benutzername in sozialen Medien, falls Sie über
          diese Kanäle mit uns interagieren, damit wir auf Ihre Kommentare, Fragen oder Ihr Feedback
          reagieren können.
        </li>
        <li>
          <strong>Angaben zu Ihrer Ausbildung:</strong> Wie z.&nbsp;B. Ausbildung, Fähigkeiten,
          Sprachkenntnisse, Berufserfahrung (nur in Fällen, in denen Sie auf eine Stellenanzeige
          antworten).
        </li>
        <li>
          <strong>Daten, die über unseren KI-Assistenten (AI Tracker) erfasst werden:</strong> Wenn Sie
          sich für die Nutzung unserer KI-Assistenten-Funktionen entscheiden, können Sie uns
          freiwillig besondere Kategorien (Gesundheit) personenbezogener Daten zur Verfügung stellen.
          Dazu gehören unter anderem: Profildaten (wie Alter, Menopausenstadium – peri/meno/post –,
          Lebensstil), Symptomdaten (z.&nbsp;B. Häufigkeit, Schweregrad), Daten zu Stimmung und
          emotionalem Zustand sowie biometrische Daten von verbundenen Geräten (falls zutreffend).
          Wir erheben diese Daten ausschließlich auf der Grundlage Ihrer ausdrücklichen, gesonderten und
          detaillierten Einwilligung (gemäß Artikel 9 der DSGVO), die vor der ersten Nutzung einer dieser
          Funktionen eingeholt wird.
        </li>
        <li>
          <strong>Verwendung von Daten in KI-Systemen:</strong> Personenbezogene Daten, die Sie dem
          KI-Assistenten zur Verfügung stellen, werden verwendet, um personalisierte Antworten zu
          generieren und Ihre Erfahrung auf der Plattform zu verbessern. Wir verwenden Ihre
          identifizierbaren personenbezogenen Daten nicht, um externe KI-Modelle zu trainieren. Soweit
          Daten zur Verbesserung unserer Dienste verwendet werden, werden sie nach Möglichkeit
          aggregiert, anonymisiert oder pseudonymisiert.
        </li>
      </ul>

      <h3>
        <FormattedMessage id="ProfileImagesSection.titleWithNumber" values={{ number: '5.1' }} />
      </h3>
      <ul>
        <li>
          <FormattedMessage id="ProfileImagesSection.cameraAccess" />
        </li>
        <li>
          <FormattedMessage id="ProfileImagesSection.usage" />
        </li>
        <li>
          <FormattedMessage id="ProfileImagesSection.storage" />
        </li>
      </ul>

      <h2>6. Integration mit Google Meet und Google Kalender</h2>
      <p>
        Wir legen großen Wert auf den Schutz Ihrer Privatsphäre und setzen uns voll und ganz für den
        Schutz Ihrer personenbezogenen Daten ein. Unsere Plattform ist mit Google Meet und Google
        Kalender integriert, um Ihnen eine nahtlose, sichere und benutzerfreundliche Erfahrung bei der
        Planung und Verwaltung virtueller Besprechungen zu bieten. Diese Integration soll Ihren
        Arbeitsablauf optimieren und es Ihnen ermöglichen, Besprechungen direkt über unsere Plattform
        zu vereinbaren, ohne dass externe Tools erforderlich sind.
      </p>
      <p>
        Die Nutzung dieser Integration und der Zugriff auf Ihren Google Kalender erfordern Ihre
        gesonderte und ausdrückliche Zustimmung, um die Sie gebeten werden, bevor Sie Ihr Konto
        verknüpfen. Sie behalten die volle Kontrolle und können diese Integration jederzeit über Ihre
        Kontoeinstellungen beenden und den Zugriff widerrufen.
      </p>
      <p>
        <strong>So funktioniert die Integration</strong>
      </p>
      <p>
        Unsere Integration mit der Google Kalender-API ermöglicht es Nutzern mit Google-Konto auf
        unserer Plattform, mühelos Besprechungen zu erstellen, zu aktualisieren und zu löschen,
        wobei Besprechungslinks automatisch über ihren Google Kalender verwaltet werden. Durch die
        Nutzung des{' '}
        <a href="https://www.googleapis.com/auth/calendar.events.owned">
          https://www.googleapis.com/auth/calendar.events.owned
        </a>
        -Scopes der Google Kalender-API gewährleisten wir einen reibungslosen Planungsprozess unter
        Einhaltung strenger Datensicherheitsstandards.
      </p>
      <p>
        <strong>Ihr Datenschutz ist uns wichtig</strong>
      </p>
      <p>
        Wir nehmen den Schutz Ihrer Daten sehr ernst. Wichtig ist, dass wir Ihre Google-Nutzerdaten
        nicht an Dritte weitergeben oder übertragen, es sei denn, dies ist zur Verbesserung und
        Bereitstellung dieser Terminplanungsfunktion erforderlich. Unsere Nutzung der Google
        Kalender-API beschränkt sich streng auf die Verbesserung Ihrer Erfahrung bei der
        Terminplanung und -verwaltung.
      </p>
      <p>
        <strong>Datensicherheit und Kontrolle</strong>
      </p>
      <p>
        Sie behalten die vollständige Kontrolle über Ihre Termine, und unsere Integration trägt zur
        Steigerung der Produktivität und Effizienz bei, ohne Ihre Privatsphäre zu beeinträchtigen. Wir
        greifen nur auf die notwendigen Informationen aus Ihrem Google Kalender zu, um die
        beabsichtigte Funktionalität bereitzustellen, und stellen sicher, dass alle Interaktionen
        sicher bleiben.
      </p>
      <p>
        <strong>Weitergabe von Daten an Dritte</strong>
      </p>
      <p>
        Wir geben Ihre Daten nicht an Dritte weiter, außer zur Ermöglichung der beschriebenen
        Funktionen von Google Meet und Google Kalender. Weitere Informationen darüber, wie Google die
        sichere Weitergabe von Nutzerdaten gewährleistet, finden Sie im{' '}
        <a href="https://support.google.com/">Google-Support-Artikel</a>.
      </p>
      <p>
        <strong>Unser Engagement für sichere Kommunikation</strong>
      </p>
      <p>
        Unsere Google Meet-Integration ist Teil unseres kontinuierlichen Engagements, Ihnen eine
        sichere, effiziente und nutzerorientierte Erfahrung zu bieten. Durch die Zentralisierung Ihrer
        Besprechungsverwaltung auf unserer Plattform helfen wir Ihnen, Ihre Kommunikationsprozesse zu
        vereinfachen und gleichzeitig strenge Datenschutzpraktiken einzuhalten. Wenn Sie Fragen oder
        Bedenken bezüglich Ihrer Privatsphäre und unserer Integration mit Google-Diensten haben,
        können Sie sich gerne an uns wenden.
      </p>

      <h2>7. Wie verwenden wir Ihre personenbezogenen Daten?</h2>
      <p>Gegebenenfalls verwenden wir Ihre Daten:</p>
      <ul>
        <li>
          <strong>Zur Abwicklung von Dienstleistungsoptionen (Erfüllung eines Vertrags):</strong> Das
          Unternehmen verarbeitet Ihre Daten, um das Vertragsverhältnis zu erfüllen, die Auswahl von
          Dienstleistungen zu bearbeiten, Kundenservice zu leisten, gesetzlichen Verpflichtungen
          nachzukommen, Zahlungsanforderungen zu erfüllen sowie Rechtsansprüche geltend zu machen oder
          auszuüben. Wenn wir Ihre Daten bei der Abwicklung Ihrer Auswahl (über unsere Service-Hotline
          oder über unseren Online-Shop) nicht erfassen, können wir Ihre Auswahl nicht bearbeiten und
          unseren gesetzlichen Verpflichtungen nicht nachkommen. Es kann erforderlich sein, Ihre Daten
          an Dritte weiterzugeben, um die von Ihnen gewählte Dienstleistung zu erbringen und zu
          bearbeiten (siehe „Wer sind die Empfänger Ihrer Daten?“).
        </li>
        <li>
          <strong>Zur Erstellung eines Benutzerkontos (Vertragserfüllung und berechtigtes Interesse):</strong>{' '}
          Das Unternehmen verarbeitet Ihre Daten, um Ihnen Kontofunktionen zur Verfügung zu stellen und
          den Abschluss der Dienstleistungserbringung zu ermöglichen.
        </li>
        <li>
          <strong>Zur Bereitstellung der KI-Assistenten-Dienste (ausdrückliche Einwilligung):</strong> Das
          Unternehmen verarbeitet Ihre Daten, um Ihnen die Verfolgung und Überwachung Ihrer
          Gesundheitssymptome zu ermöglichen und Ihnen KI-gestützte Anleitungen, personalisierte
          Unterstützung und Gesundheitsempfehlungen auf der Grundlage der von Ihnen eingegebenen Daten
          bereitzustellen. Die Verarbeitung Ihrer Daten besonderer Kategorien (Gesundheitsdaten) zu
          diesen Zwecken erfolgt ausschließlich auf der Grundlage Ihrer ausdrücklichen und gesonderten
          Einwilligung (Art.&nbsp;9 der DSGVO).
        </li>
        <li>
          <strong>Zweck und Einschränkungen der KI:</strong> Der KI-Assistent dient ausschließlich
          allgemeinen Wellness-, Bildungs- und Informationszwecken. Er bietet keine medizinische
          Beratung, Diagnose, Behandlung oder Unterstützung bei klinischen Entscheidungen. Von der KI
          generierte Ergebnisse können unvollständig, ungenau oder nicht auf Ihren spezifischen
          Gesundheitszustand zugeschnitten sein. Sie sollten sich bei medizinischen Entscheidungen
          nicht auf KI-generierte Inhalte verlassen und stets einen qualifizierten Arzt konsultieren.
        </li>
        <li>
          <strong>
            Für die Integration mit Google Meet und Google Kalender (ausdrückliche Einwilligung):
          </strong>{' '}
          Das Unternehmen verarbeitet Ihre Daten, um die Erstellung, Aktualisierung und Löschung Ihrer
          Termine direkt über die Plattform zu ermöglichen, indem diese mit Ihrem Google Kalender
          synchronisiert werden. Diese Funktion wird ausschließlich auf der Grundlage Ihrer
          ausdrücklichen und gesonderten Einwilligung zur Verknüpfung Ihres Google-Kontos aktiviert.
        </li>
        <li>
          <strong>Für die Kommunikation (berechtigtes Interesse):</strong> Das Unternehmen verwendet Ihre
          Daten, um auf Ihre Anfragen/Fragen, Rückerstattungsanträge und/oder etwaige Beschwerden zu
          reagieren. Die Informationen, die Sie uns mitteilen, ermöglichen es uns, Ihre Anfragen zu
          bearbeiten und Ihnen bestmöglich zu antworten. Wir können Ihre Anfragen/Wünsche an uns auch
          aufzeichnen, um auf zukünftige Mitteilungen besser reagieren zu können. Wir tun dies auf der
          Grundlage unserer vertraglichen Verpflichtungen Ihnen gegenüber, unserer gesetzlichen
          Verpflichtungen und unserer berechtigten Interessen, Ihnen den bestmöglichen Service zu bieten
          und unsere Dienstleistungen auf der Grundlage Ihrer persönlichen Erfahrungen zu verbessern.
        </li>
        <li>
          <strong>Zum Versand von Newslettern/Angeboten (Einwilligung):</strong> Mit Ihrer Einwilligung
          verwenden wir Ihre personenbezogenen Daten, Präferenzen und Transaktionsdaten, um Sie per
          E-Mail, Internet, Telefon und/oder über soziale Medien über entsprechende Dienstleistungen,
          einschließlich personalisierter Angebote, zu informieren. Sie können diese Einwilligung
          jederzeit widerrufen.
        </li>
        <li>
          <strong>Für Web-Push-Benachrichtigungen (Einwilligung):</strong> Abhängig von Ihrem
          Surfverhalten können Sie, sofern Sie zuvor Ihre Einwilligung erteilt haben, Benachrichtigungen
          über unsere Angebote, Neuigkeiten, Ihre Wunschliste sowie Ihre wichtigsten Präferenzen und
          Auswahlen erhalten. Sie können diese Einwilligung jederzeit widerrufen.
        </li>
        <li>
          <strong>Für die Teilnahme an einem Prämienprogramm:</strong> Das Unternehmen kann Ihre Daten
          für die Zwecke Ihrer Teilnahme an einem Prämienprogramm verarbeiten, d.&nbsp;h. sowohl für die
          Prüfung Ihres Teilnahmeantrags als auch für das Sammeln und Einlösen von Punkten sowie
          allgemein für die Inanspruchnahme von Kundenprivilegien. Dies ermöglicht es uns, Ihnen
          personalisierte Angebote zu unterbreiten, die Sie interessieren.
        </li>
        <li>
          <strong>Zur Entwicklung und Verbesserung der Optionen, Angebote, des Betriebs und der Dienste:</strong>{' '}
          Wir tun dies auf der Grundlage unserer berechtigten Geschäftsinteressen.
        </li>
        <li>
          <strong>Um relevante Angebote und Vorschläge zu unterbreiten:</strong> Wir möchten Ihnen Angebote
          und Vorschläge unterbreiten, die für Ihre Interessen und Bedürfnisse relevanter sind.
        </li>
        <li>
          <strong>Um Ihnen interessante Inhalte anzuzeigen:</strong> Wir können eine Liste der zuletzt
          angesehenen Dienste anzeigen oder Empfehlungen auf der Grundlage Ihres Auswahlverlaufs und der
          Daten, die Sie uns mitgeteilt haben, gemäß Ihrer Einwilligung zu Cookies oder Benachrichtigungen
          unterbreiten.
        </li>
        <li>
          <strong>Um Ihnen Umfragen und Bewertungsanfragen zu senden:</strong> Damit wir unsere Dienste
          verbessern können. Diese Nachrichten enthalten keine Werbeinhalte und erfordern keine
          vorherige Einwilligung, wenn sie per E-Mail oder SMS versendet werden. Sie können sich jederzeit
          abmelden.
        </li>
        <li>
          <strong>Um Ihr Konto vor Betrug und anderen illegalen Aktivitäten zu schützen:</strong> Dies
          umfasst die Verwendung Ihrer Daten zur Pflege, Aktualisierung und zum Schutz Ihres Kontos.
          Wir überwachen außerdem die Browsing-Aktivitäten auf unserer Website, um Probleme schnell zu
          erkennen und zu beheben und die Integrität unserer Website zu schützen.
        </li>
        <li>
          <strong>
            Zur Abwicklung von Zahlungen und zur Verhinderung betrügerischer Transaktionen (berechtigtes
            Interesse und gesetzliche Verpflichtung):
          </strong>{' '}
          Dies trägt dazu bei, unsere Kunden vor Betrug und Cybervorfällen zu schützen.
        </li>
        <li>
          <strong>Zur Erfüllung unserer vertraglichen Verpflichtungen oder gesetzlicher Vorschriften:</strong>{' '}
          Zum Beispiel Aktualisierungen dieser Datenschutzhinweise, Widerrufsbelehrungen und gesetzlich
          vorgeschriebene Informationen zu Ihren Wahlmöglichkeiten.
        </li>
        <li>
          <strong>Verarbeitung im Auftrag von Spezialisten (als Auftragsverarbeiter):</strong> Wenn Sie
          über die Plattform mit einem „Spezialisten“ interagieren, verarbeiten wir Ihre
          personenbezogenen Daten (wie Kommunikationsinhalte, Terminangaben) als Auftragsverarbeiter im
          Auftrag des „Spezialisten“ (der der Verantwortliche ist), um die Erbringung seiner
          Dienstleistung für Sie zu ermöglichen.
        </li>
      </ul>

      <p>
        Die Verarbeitung erfolgt entweder durch speziell befugtes Personal des Unternehmens oder über
        IT-Systeme und elektronische Geräte des Unternehmens sowie in Ausnahmefällen durch Dritte, die
        sich vertraglich zur Vertraulichkeit und zum Schutz Ihrer Daten verpflichtet haben und Aufgaben
        ausführen, die zur Erreichung der Zwecke erforderlich sind, die in engem Zusammenhang mit der
        Nutzung unserer Websites und Dienste stehen. Informationen hierzu finden Sie weiter unten unter{' '}
        „Wer sind die Empfänger Ihrer Daten? Wie werden Ihre Daten weitergegeben?“.
      </p>

      <h2>8. Was ist die Rechtsgrundlage für die Verarbeitung Ihrer Daten durch das Unternehmen?</h2>
      <p>
        Wir verarbeiten Ihre personenbezogenen Daten rechtmäßig, transparent und nach Treu und
        Glauben. Je nach dem Zweck, zu dem wir Ihre Daten verwenden (siehe Abschnitt 7), stützen wir
        uns auf folgende Rechtsgrundlagen gemäß der DSGVO:
      </p>
      <ul>
        <li>
          <strong>Erfüllung eines Vertrags (Art. 6 Abs. 1 Buchstabe b DSGVO):</strong> Z.&nbsp;B. die
          Einrichtung und Pflege Ihres Benutzerkontos, die Abwicklung von Zahlungen und die Erbringung
          der von Ihnen angeforderten Dienstleistungen.
        </li>
        <li>
          <strong>Erfüllung einer rechtlichen Verpflichtung (Art. 6 Abs. 1 Buchstabe c DSGVO):</strong>{' '}
          Z.&nbsp;B. Speicherung von Transaktionsdaten gemäß steuer- und rechnungslegungsrechtlichen
          Vorschriften, Beantwortung rechtlicher Anfragen.
        </li>
        <li>
          <strong>Ihre Einwilligung (Art. 6 Abs. 1 Buchstabe a DSGVO):</strong> Für bestimmte
          Aktivitäten, die nicht unter andere Rechtsgrundlagen fallen, wie z.&nbsp;B. den Versand von
          Newslettern, Web-Push-Benachrichtigungen und das Setzen von Analyse- oder Werbe-Cookies.
        </li>
        <li>
          <strong>Unser berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO):</strong> Z.&nbsp;B.
          Schutz Ihres Kontos vor Betrug, Verhinderung betrügerischer Transaktionen, Entwicklung und
          Verbesserung von Dienstleistungen sowie Aufrechterhaltung der Sicherheit unseres Netzwerks
          und unserer IT-Systeme.
        </li>
        <li>
          <strong>
            Verarbeitung von Daten besonderer Kategorien (Gesundheitsdaten) (Art. 9 DSGVO):
          </strong>{' '}
          Für die Verarbeitung Ihrer Daten besonderer Kategorien (Gesundheits- und biometrische
          Daten) (z.&nbsp;B. über den KI-Assistenten) stützen wir uns auf Ihre ausdrückliche und
          gesonderte Einwilligung (Art.&nbsp;9 Abs.&nbsp;2 Buchstabe a DSGVO), die vor der ersten
          Nutzung der entsprechenden Funktion eingeholt wird.
        </li>
      </ul>
      <p>
        Bei der Erhebung Ihrer personenbezogenen Daten informieren wir Sie stets darüber, welche Daten
        obligatorisch (mit einem Sternchen * gekennzeichnet) und welche optional sind, sowie über die
        Folgen einer Nichtangabe.
      </p>

      <h2>9. Wer sind die Empfänger:innen Ihrer Daten?</h2>
      <p>
        Zugriff auf Ihre Daten erhalten nur die Mitarbeiter des Unternehmens, für die dies unbedingt
        erforderlich ist und die zur Vertraulichkeit verpflichtet sind, sowie mit uns kooperierende
        Unternehmen oder externe Dienstleister, die Ihre Daten als Auftragsverarbeiter in unserem Auftrag
        und gemäß unseren Anweisungen verarbeiten.
      </p>

      <h2>10. Wie werden Ihre Daten weitergegeben?</h2>

      <h3>10.1 Drittanbieter von Dienstleistungen (Auftragsverarbeiter)</h3>
      <p>
        Dies sind Unternehmen, die personenbezogene Daten in unserem Auftrag und nach unseren
        Anweisungen verarbeiten. Wir schließen mit ihnen Verträge (DPAs) ab, die sie dazu verpflichten,
        geeignete technische und organisatorische Maßnahmen zum Schutz Ihrer personenbezogenen Daten zu
        ergreifen. Dazu gehören:
      </p>
      <ul>
        <li>
          <strong>Hosting- und Cloud-Infrastrukturanbieter:</strong> Unternehmen, die Serverplatz und
          Infrastruktur für den Betrieb der Plattform bereitstellen (z.&nbsp;B. AWS, Render).
        </li>
        <li>
          <strong>KI-Dienstleister:</strong> Damit unser KI-Assistent (AI Tracker) funktioniert,
          übermitteln wir Daten (einschließlich Gesundheitsdaten, jedoch nur nach Ihrer ausdrücklichen
          Einwilligung) an unseren Technologiepartner Anthropic (Claude AI) mit Sitz in den USA.
        </li>
        <li>
          <strong>Transparenz bei KI-Dienstleistern:</strong> Bei der Nutzung von KI-Funktionen können
          Ihre Daten von externen KI-Dienstleistern verarbeitet werden, die als Auftragsverarbeiter
          fungieren. Diese Anbieter verarbeiten Daten streng nach unseren Anweisungen und dürfen Ihre
          personenbezogenen Daten vertraglich nicht für eigene, unabhängige Zwecke verwenden. Wir setzen
          angemessene Sicherheitsvorkehrungen um, darunter Datenminimierung, Verschlüsselung und
          vertragliche Beschränkungen, um sicherzustellen, dass KI-Anbieter Ihre Daten in
          Übereinstimmung mit der DSGVO und den geltenden KI-Vorschriften verarbeiten.
        </li>
        <li>
          <strong>Zahlungsdienstleister (PSPs):</strong> Zur Abwicklung von Kreditkarten und Zahlungen.
          Wir speichern Ihre Kartendaten nicht; diese werden direkt von diesen Anbietern verarbeitet,
          die PCI-DSS-zertifiziert sind.
        </li>
        <li>
          <strong>Analytik-Dienstleister:</strong> Um zu verstehen, wie unsere Plattform genutzt wird,
          geben wir Daten (z.&nbsp;B. über Cookies) an Partner wie Google Analytics weiter.
        </li>
        <li>
          <strong>Marketing- und Kommunikationsdienstleister:</strong> Für den Versand von E-Mails
          (Newsletter), Umfragen und Analysen. Wir verkaufen, vermieten oder tauschen Ihre
          personenbezogenen Daten nicht gegen Geld an Dritte.
        </li>
      </ul>

      <h3>10.2 „Spezialisten“ in ihrer Rolle als Verantwortliche</h3>
      <p>
        Wenn Sie als „Nutzer“ über die Plattform Kontakt zu einem „Spezialisten“ (professioneller
        Nutzer) aufnehmen oder eine Dienstleistung bei diesem buchen, geben wir die erforderlichen Daten
        (wie Name, E-Mail-Adresse, Terminangaben und gegebenenfalls von Ihnen eingegebene
        Gesundheitsdaten) an diesen „Spezialisten“ weiter. In diesem Fall fungiert der „Spezialist“ als
        eigenständiger Verantwortlicher für Ihre Daten, und wir agieren in seinem Auftrag als
        Auftragsverarbeiter, um die Erbringung der Dienstleistung zu ermöglichen.
      </p>

      <h3>10.3 Andere Dritte mit Ihrer Einwilligung oder auf Ihre Initiative</h3>
      <p>
        Dies sind Dritte, denen Sie selbst die Weitergabe von Daten gestattet haben. Beispiel: Wenn Sie
        ausdrücklich zustimmen, Ihren Google Kalender für die Terminverwaltung zu verknüpfen.
      </p>

      <h3>10.4 Behörden und gesetzliche Verpflichtungen</h3>
      <p>
        Wir geben Daten an andere Dritte weiter, soweit dies für die folgenden Zwecke erforderlich ist:
      </p>
      <ul>
        <li>
          (i) Einhaltung der Vorschriften auf Anordnung einer zuständigen griechischen Behörde, aufgrund
          eines Gerichtsbeschlusses oder gemäß geltendem Recht.
        </li>
        <li>
          (ii) Verhinderung der rechtswidrigen Nutzung unserer Plattform oder von Verstößen gegen unsere
          Nutzungsbedingungen und Richtlinien.
        </li>
        <li>(iii) Unser eigener Schutz vor Ansprüchen Dritter.</li>
        <li>(iv) Beitrag zur Verhinderung oder Aufklärung von Betrugsfällen.</li>
      </ul>

      <h3>10.5 Weitergabe von Daten durch Sie</h3>
      <p>
        Wenn Sie bestimmte Social-Media-Funktionen auf unserer Plattform nutzen, erstellen Sie
        möglicherweise ein öffentliches Profil, das Informationen wie Ihren Benutzernamen, Ihr
        Profilbild und Ihren Wohnort enthält. Sie können außerdem Inhalte mit Ihren Freunden oder der
        Öffentlichkeit teilen, darunter auch Informationen über Ihre Interaktion mit dem Unternehmen.
        Wir empfehlen Ihnen, die von uns bereitgestellten Tools zur Verwaltung der Freigabe in den sozialen
        Medien des Unternehmens zu nutzen, um die von Ihnen bereitgestellten Informationen zu
        kontrollieren.
      </p>

      <h2>11. Welche Richtlinie wenden wir bei Dritt-Auftragsverarbeitern an?</h2>
      <p>
        Diejenigen, die die Verarbeitung in unserem Auftrag durchführen, haben sich gegenüber dem
        Unternehmen verpflichtet und vertraglich zugesichert, dass sie:
      </p>
      <ul>
        <li>die Vertraulichkeit wahren;</li>
        <li>Ihre Daten nicht ohne die Zustimmung des Unternehmens an Dritte weitergeben;</li>
        <li>geeignete Sicherheitsmaßnahmen zu ergreifen;</li>
        <li>
          die gesetzlichen Rahmenbedingungen zum Schutz personenbezogener Daten und insbesondere die
          DSGVO einzuhalten.
        </li>
      </ul>
      <p>
        Um Ihr Kundenerlebnis auf unseren Websites und in unseren Apps zu verbessern, nutzen wir die
        oben genannten Dienstleister, die Ihre personenbezogenen Daten im Rahmen ihrer Verträge mit uns
        verarbeiten. Wenn Sie weitere Informationen über die Weitergabe Ihrer Daten an Dritte erhalten
        möchten, kontaktieren Sie uns bitte per E-Mail unter{' '}
        <a href="mailto:info@vivianlab.com">info@vivianlab.com</a>.
      </p>

      <h2>12. Wie stellen wir sicher, dass Auftragsverarbeiter Ihre Daten respektieren?</h2>
      <p>
        Diejenigen, die die Verarbeitung in unserem Auftrag durchführen, haben sich gegenüber dem
        Unternehmen verpflichtet und vertraglich zugesichert, dass sie:
      </p>
      <ul>
        <li>die Vertraulichkeit wahren;</li>
        <li>Ihre Daten nicht ohne die Zustimmung des Unternehmens an Dritte weitergeben;</li>
        <li>geeignete Sicherheitsmaßnahmen zu ergreifen;</li>
        <li>
          die gesetzlichen Rahmenbedingungen zum Schutz personenbezogener Daten und insbesondere die
          DSGVO einzuhalten.
        </li>
      </ul>
      <p>
        Um Ihr Kundenerlebnis auf unseren Websites und in unseren Apps zu verbessern, nutzen wir die
        oben genannten Dienstleister, die Ihre personenbezogenen Daten im Rahmen ihrer Verträge mit uns
        verarbeiten. Wenn Sie weitere Informationen über die Weitergabe Ihrer Daten an Dritte erhalten
        möchten, kontaktieren Sie uns bitte per E-Mail unter{' '}
        <a href="mailto:info@vivianlab.com">info@vivianlab.com</a>.
      </p>

      <h2>13. Datenübermittlung</h2>
      <p>
        Die personenbezogenen Daten, die wir im Rahmen unserer Plattform erheben (oder verarbeiten),
        werden in erster Linie innerhalb der Europäischen Union (EU) und des Europäischen
        Wirtschaftsraums (EWR) gespeichert, beispielsweise auf unseren Hauptservern, die in Deutschland
        gehostet werden.
      </p>
      <p>
        Um jedoch bestimmte Dienste und Funktionen bereitzustellen, können sich einige der
        Datenempfänger, an die das Unternehmen Ihre personenbezogenen Daten weitergibt, in Ländern
        außerhalb des EWR („Drittländer“) befinden. Dazu gehören insbesondere:
      </p>
      <ul>
        <li>
          <strong>a) Hosting- und Cloud-Infrastrukturanbieter:</strong> Soweit VivianLab LTD Amazon Web
          Services, Inc. („AWS“) als Hosting- und Cloud-Infrastrukturanbieter für die Verarbeitung
          Ihrer personenbezogenen Daten nutzt, fungiert AWS gemäß der DSGVO als Auftragsverarbeiter im
          Auftrag des Unternehmens. Die Beziehung zwischen dem Unternehmen und AWS unterliegt dem
          AWS-Datenverarbeitungszusatz („AWS DPA“), der in die AWS-Nutzungsbedingungen integriert und
          auf der AWS-Website verfügbar ist. Soweit AWS-Dienste die Übermittlung Ihrer
          personenbezogenen Daten aus dem EWR in Länder außerhalb des EWR (einschließlich der USA)
          beinhalten, stellt das Unternehmen angemessene Garantien gemäß Artikel 46 DSGVO sicher,
          insbesondere durch die Standardvertragsklauseln (SCCs).
        </li>
        <li>
          <strong>b) KI-Dienstleister:</strong> Damit unser KI-Assistent (AI Tracker) funktioniert,
          übermitteln wir Daten an unseren Technologiepartner Anthropic (Claude AI) mit Sitz in den
          Vereinigten Staaten von Amerika (USA).
        </li>
        <li>
          <strong>c) Analysedienstleister:</strong> Für Webanalysen nutzen wir Dienste wie Google
          Analytics, was die Übermittlung von Daten in die USA beinhalten kann.
        </li>
      </ul>
      <p>
        Die Rechtsvorschriften in diesen Ländern (wie den USA) bieten möglicherweise nicht das gleiche
        Datenschutzniveau wie im EWR. Wir verpflichten uns zum Schutz Ihrer personenbezogenen Daten und
        ergreifen alle erforderlichen Maßnahmen, um die geltenden gesetzlichen Anforderungen für solche
        Übermittlungen zu erfüllen. Um sicherzustellen, dass Ihre personenbezogenen Daten angemessen
        geschützt sind, stützen wir uns in erster Linie auf die von der Europäischen Kommission
        genehmigten Standardvertragsklauseln (SCCs).
      </p>
      <p>
        Speziell für die Übermittlung Ihrer Daten besonderer Kategorien (Gesundheitsdaten) an unsere
        KI-Partner in den USA stützen wir uns zusätzlich zu den Standardvertragsklauseln auf Ihre
        ausdrückliche und gesonderte Einwilligung zu einer solchen Übermittlung, die vor der Nutzung des
        KI-Assistenten-Dienstes eingeholt wird. Durch die Nutzung der Plattform erkennen Sie an, dass
        Ihre Daten in Länder außerhalb Ihrer Gerichtsbarkeit, einschließlich der Vereinigten Staaten,
        übermittelt und dort verarbeitet werden können, wo die Datenschutzgesetze von denen in Ihrem
        Land abweichen können.
      </p>

      <h2>14. Wie lange speichern wir Ihre Daten?</h2>
      <p>
        Wir speichern Ihre personenbezogenen Daten so lange, wie es zur Erfüllung der in dieser
        Datenschutzerklärung genannten Zwecke erforderlich ist (es sei denn, geltendes Recht schreibt
        eine längere Aufbewahrungsfrist vor).
      </p>
      <p>
        Im Allgemeinen bedeutet dies, dass wir Ihre personenbezogenen Daten im Zusammenhang mit Ihrem
        Konto so lange speichern, wie Sie ein aktives Konto bei unserem Unternehmen haben.
      </p>
      <p>
        Ihre personenbezogenen Daten im Zusammenhang mit den von uns angebotenen Dienstleistungen (z.&nbsp;B.
        Transaktionsdaten) speichern wir über einen längeren Zeitraum, um unseren gesetzlichen
        Verpflichtungen (wie z.&nbsp;B. steuer- und handelsrechtlichen Vorschriften) nachzukommen.
      </p>
      <p>
        Nach Ablauf dieser Aufbewahrungsfrist werden Ihre Daten vollständig gelöscht oder anonymisiert,
        beispielsweise durch Zusammenführung mit anderen Daten, sodass sie in nicht identifizierbarer
        Form für statistische Analysen und die Geschäftsplanung verwendet werden können.
      </p>
      <p>Einige Beispiele für Aufbewahrungsfristen:</p>
      <ul>
        <li>
          <strong>Konto- und Dienstleistungsdaten (Kundenregister):</strong> Wir speichern Ihre
          grundlegenden Kontodaten, solange Ihr Konto aktiv ist. Daten im Zusammenhang mit Transaktionen
          und der Erbringung von Dienstleistungen werden für fünf (5) Jahre nach Beendigung des
          Vertragsverhältnisses gespeichert.
        </li>
        <li>
          <strong>Newsletter-Daten (Marketingregister):</strong> Ihre Einwilligung und die Daten für
          den Versand des Newsletters (Name, E-Mail) werden gespeichert, bis Sie Ihre Einwilligung
          widerrufen.
        </li>
        <li>
          <strong>
            Aufgrund der Sensibilität dieser Daten gelten folgende Fristen (KI-Assistent / AI Tracker):
          </strong>{' '}
          aktive Verarbeitung, solange Sie die Funktion nutzen; wenn Sie inaktiv werden, können wir die
          Daten für einen begrenzten Zeitraum aufbewahren (z.&nbsp;B. 18 Monate nach Ihrer letzten
          Aktivität). Bei ausdrücklicher Schließung Ihres Profils oder auf Ihren Antrag auf Löschung
          werden Ihre persönlichen Gesundheitsdaten aus dem KI-Assistenten dauerhaft gelöscht.
        </li>
      </ul>

      <h2>15. Sind Ihre Daten sicher?</h2>
      <p>
        VivianLab verpflichtet sich, Ihre personenbezogenen Daten mithilfe branchenführender
        Sicherheitsmaßnahmen zu schützen. Wir sind uns der Bedeutung des Schutzes Ihrer Daten,
        insbesondere sensibler Gesundheitsdaten, bewusst und haben umfassende technische und
        organisatorische Sicherheitsvorkehrungen für den gesamten Datenlebenszyklus getroffen.
      </p>

      <h3>15.1 Technische Sicherheitsmaßnahmen</h3>
      <h4>(a) Verschlüsselung bei der Übertragung</h4>
      <p>
        Alle Daten, die zwischen Ihrem Gerät (Webbrowser oder mobile Anwendung) und unseren Servern
        übertragen werden, sind mittels HTTPS mit Transport Layer Security (TLS) 1.2 oder höher
        gesichert. Dieses Verschlüsselungsprotokoll verhindert das Abfangen, Abhören oder Manipulieren
        Ihrer Daten während der Übertragung über das Internet.
      </p>

      <h4>(b) Verschlüsselung im Ruhezustand</h4>
      <p>
        Personenbezogene Daten, die in unseren Datenbanken und Speichersystemen gespeichert sind,
        werden mittels AES-256-Verschlüsselung geschützt. Dies gewährleistet, dass Ihre Daten auch im
        unwahrscheinlichen Fall einer Kompromittierung der physischen Infrastruktur sicher bleiben.
      </p>

      <h4>(c) Passwortsicherheit</h4>
      <p>
        Ihr Kontopasswort wird niemals im Klartext gespeichert. Wir verwenden starke, einseitige
        kryptografische Hash-Algorithmen mit Salting (bcrypt oder gleichwertig), um Ihre Anmeldedaten
        zu schützen. Nicht einmal unsere Systemadministratoren können Ihr tatsächliches Passwort
        einsehen. Jedes Passwort wird mit einem einzigartigen zufälligen Salt gehasht, und nur Sie
        kennen Ihr Passwort.
      </p>

      <h3>15.2 Zahlungssicherheit</h3>
      <p>
        Die Zahlungsinfrastruktur von VivianLab ist so konzipiert, dass keine unverschlüsselten
        Karteninhaberdaten auf unseren Servern gespeichert, übertragen oder verarbeitet werden. Die
        gesamte Zahlungsabwicklung wird an Stripe delegiert, einen weltweit anerkannten
        Zahlungsanbieter, der als PCI-DSS-Level-1-Dienstleister zertifiziert ist.
      </p>
      <p>
        Wenn Sie Ihre Zahlungsdaten eingeben, werden diese Informationen über TLS-verschlüsselte
        Verbindungen direkt von Ihrem Browser an die Server von Stripe übertragen, wobei das Backend
        von VivianLab vollständig umgangen wird. Stripe tokenisiert Ihre Kartendaten; VivianLab speichert
        lediglich ein Token, nicht Ihre tatsächlichen Kartendaten.
      </p>

      <h3>15.3 Infrastruktur- und Plattformsicherheit</h3>
      <p>
        Unsere Plattform basiert auf einer sicheren Marktplatz-Infrastruktur (wie z.&nbsp;B.
        Sharetribe) mit Verschlüsselung während der Übertragung (TLS 1.2+) und bei der Speicherung
        (AES-256). Unsere Infrastruktur wird bei sicheren Cloud-Anbietern (z.&nbsp;B. AWS, Azure)
        gehostet, die über Zertifizierungen nach ISO 27001, SOC 2 und ähnliche Standards verfügen. Die
        physische Sicherheit, die Netzwerksicherheit und die Redundanz werden von diesen Anbietern
        gewährleistet.
      </p>

      <h3>15.4 Organisatorische Sicherheitsmaßnahmen</h3>
      <ul>
        <li>Rollenbasierte Zugriffskontrolle (RBAC)</li>
        <li>Prinzip der geringsten Berechtigungen</li>
        <li>Prüfprotokolle und Überwachung</li>
        <li>Betriebsumgebungen mit eingeschränktem Zugriff</li>
        <li>Vertraulichkeitsverpflichtungen für Mitarbeiter und Auftragnehmer</li>
        <li>Regelmäßige Schulungen zu Sicherheit und DSGVO</li>
        <li>Pläne für die Reaktion auf Vorfälle und zur Aufrechterhaltung des Geschäftsbetriebs</li>
      </ul>

      <h3>15.5 Sicherheit personenbezogener Daten – Übersichtstabelle</h3>
      <p>Die folgende Tabelle fasst zentrale Schutzmaßnahmen zusammen:</p>
      <table>
        <thead>
          <tr>
            <th>Datenkategorie</th>
            <th>Beispiele</th>
            <th>Verschlüsselung bei der Übertragung</th>
            <th>Verschlüsselung im Ruhezustand</th>
            <th>Zusätzliche Sicherheitsmaßnahmen</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Zugangsdaten</td>
            <td>Nutzername, Passwort, E-Mail</td>
            <td>HTTPS/TLS 1.2+</td>
            <td>AES-256</td>
            <td>Passwort-Hashing (bcrypt + Salt), Sitzungsverwaltung, optionale MFA</td>
          </tr>
          <tr>
            <td>Personenbezogene Identifikationsdaten</td>
            <td>Name, Nachname, Geburtsdatum, Land, Stadt, Adresse, Telefon</td>
            <td>HTTPS/TLS 1.2+</td>
            <td>AES-256</td>
            <td>RBAC, Audit-Logging, Datenminimierung</td>
          </tr>
          <tr>
            <td>Zahlungsinformationen</td>
            <td>Name Karteninhaber, Kartennummer, CVV, Ablaufdatum, Rechnungsadresse</td>
            <td>Direkt an Stripe über TLS</td>
            <td>Tokenisiert, keine Rohkartendaten gespeichert</td>
            <td>PCI DSS Level 1 über Stripe, Tokenisierung, 3D Secure, Betrugserkennung</td>
          </tr>
          <tr>
            <td>Transaktionsmetadaten</td>
            <td>Transaktions-ID, Betrag, Datum, Status</td>
            <td>HTTPS/TLS 1.2+</td>
            <td>AES-256</td>
            <td>Audit-Logs, Aufbewahrung gemäß Steuerrecht</td>
          </tr>
          <tr>
            <td>Gesundheitsdaten</td>
            <td>Symptome, Menopausenstadium, Stimmung, biometrische Daten aus Wearables, Lebensstil</td>
            <td>HTTPS/TLS 1.2+</td>
            <td>AES-256</td>
            <td>
              Ausdrückliche Einwilligung, getrennte Speicherung, Pseudonymisierung soweit anwendbar,
              begrenzte Aufbewahrung, Datenschutz-Folgenabschätzung
            </td>
          </tr>
          <tr>
            <td>Beratungs- und Termindaten</td>
            <td>Termindaten, Name Spezialist:in, Notizen</td>
            <td>HTTPS/TLS 1.2+</td>
            <td>AES-256</td>
            <td>Rolle als Auftragsverarbeiter im Auftrag des Spezialisten, RBAC, Audit-Logs, sichere Kanäle</td>
          </tr>
          <tr>
            <td>Google-Calendar-Integrationsdaten</td>
            <td>Ereignisse, Meeting-Links, Metadaten</td>
            <td>HTTPS/TLS 1.2+ (OAuth 2.0)</td>
            <td>AES-256 (Tokens)</td>
            <td>
              Ausdrückliche Einwilligung, begrenzter Umfang, nutzergesteuerter Widerruf,
              Google-API-Sicherheit
            </td>
          </tr>
          <tr>
            <td>Newsletter- und Marketingdaten</td>
            <td>E-Mail, Name, Einwilligungsnachweise</td>
            <td>HTTPS/TLS 1.2+</td>
            <td>AES-256</td>
            <td>Einwilligungsbasiert, Abmeldelink, Einwilligungsprotokolle</td>
          </tr>
          <tr>
            <td>Cookies- und Analysedaten</td>
            <td>IP, Geräte-ID, Browserinformationen, Nutzungsmuster</td>
            <td>HTTPS/TLS 1.2+</td>
            <td>AES-256, soweit gespeichert</td>
            <td>Anonymisierung/Pseudonymisierung, Consent Management, Aufbewahrungsgrenzen</td>
          </tr>
          <tr>
            <td>Social-Media-Daten</td>
            <td>Nutzername, öffentliches Profil, Interaktionen</td>
            <td>HTTPS/TLS 1.2+</td>
            <td>AES-256</td>
            <td>Nur öffentliche Daten, begrenzte Aufbewahrung, nutzergesteuerte Weitergabe</td>
          </tr>
          <tr>
            <td>Technische und Gerätedaten</td>
            <td>IP-Adresse, Betriebssystem, Geräte-ID, Sprache, Zeitzone</td>
            <td>HTTPS/TLS 1.2+</td>
            <td>AES-256</td>
            <td>
              IP-Pseudonymisierung, Aggregation, Richtlinien zur Log-Aufbewahrung,
              Sicherheitsmonitoring
            </td>
          </tr>
          <tr>
            <td>Bewerbungsdaten</td>
            <td>Lebenslauf, Ausbildung, Fähigkeiten, Berufserfahrung</td>
            <td>HTTPS/TLS 1.2+</td>
            <td>AES-256</td>
            <td>
              Zugriff beschränkt auf HR/Recruiting-Verantwortliche, begrenzte Aufbewahrung,
              sichere Löschung
            </td>
          </tr>
        </tbody>
      </table>

      <h3>15.6 Kontinuierliche Verbesserung der Sicherheit</h3>
      <p>Wir verpflichten uns zu kontinuierlicher Verbesserung durch:</p>
      <ul>
        <li>Regelmäßige Sicherheitsaudits</li>
        <li>Schwachstellen-Scans und Penetrationstests</li>
        <li>Verwaltung von Sicherheitspatches</li>
        <li>Überwachung der Compliance</li>
        <li>Übungen zur Reaktion auf Sicherheitsvorfälle</li>
        <li>Beobachtung neu auftretender Sicherheitsbedrohungen</li>
      </ul>

      <h3>15.7 Ihre Rolle bei der Sicherheit</h3>
      <p>Sie sollten:</p>
      <ul>
        <li>Ihr Passwort geheim halten und sicher gestalten</li>
        <li>Sich nach der Nutzung auf gemeinsam genutzten Geräten abmelden</li>
        <li>MFA aktivieren, sofern verfügbar</li>
        <li>Ihr Konto überwachen und verdächtige Aktivitäten melden</li>
        <li>Ihre Geräte und Software auf dem neuesten Stand halten</li>
        <li>Auf Phishing-Versuche achten</li>
      </ul>

      <h3>15.8 Benachrichtigung bei Datenschutzverletzungen</h3>
      <p>
        Im unwahrscheinlichen Fall einer Verletzung des Schutzes personenbezogener Daten, die ein Risiko
        für Ihre Rechte und Freiheiten darstellt, werden wir die zuständige Aufsichtsbehörde innerhalb
        von 72 Stunden benachrichtigen und, sofern erforderlich, die betroffenen Personen unverzüglich
        gemäß den Artikeln 33 und 34 der DSGVO informieren.
      </p>
      <p>
        Sie können vermutete Sicherheitsvorfälle oder Datenschutzverletzungen an{' '}
        <a href="mailto:info@vivianlab.com">info@vivianlab.com</a> melden.
      </p>

      <h3>15.9 Sicherheit durch Drittanbieter:innen</h3>
      <p>
        Alle Drittanbieter und Auftragsverarbeiter, an die wir Ihre Daten weitergeben, sind vertraglich
        verpflichtet:
      </p>
      <ul>
        <li>geeignete technische und organisatorische Sicherheitsmaßnahmen zu ergreifen</li>
        <li>Daten ausschließlich gemäß unseren dokumentierten Anweisungen zu verarbeiten</li>
        <li>die Vertraulichkeit zu wahren</li>
        <li>uns über Datenverletzungen oder Sicherheitsvorfälle zu informieren</li>
        <li>die DSGVO und geltende Datenschutzgesetze einzuhalten</li>
        <li>sich gegebenenfalls Audits und Sicherheitsbewertungen zu unterziehen</li>
      </ul>

      <h3>15.10 Transparenz, Risiken und Schutzmaßnahmen von KI-Systemen</h3>
      <p>
        In Übereinstimmung mit dem EU-Gesetz über künstliche Intelligenz stellen wir folgende
        Informationen zu unseren KI-Systemen bereit:
      </p>
      <p>
        <strong>Art des KI-Systems:</strong> Die auf der Plattform verfügbaren KI-Funktionen sind als
        Systeme mit begrenztem Risiko eingestuft, die für Wellness- und Informationszwecke konzipiert
        sind.
      </p>
      <p>
        <strong>Bekannte Einschränkungen und Risiken:</strong> KI-generierte Ergebnisse können:
      </p>
      <ul>
        <li>● Ungenauigkeiten oder Fehler enthalten</li>
        <li>● Unvollständig oder veraltet sein</li>
        <li>● Den individuellen Gesundheitszustand nicht widerspiegeln</li>
        <li>● Durch die vom Nutzer bereitgestellten Daten beeinflusst werden</li>
      </ul>
      <p>
        <strong>Menschliche Aufsicht:</strong> Unsere KI-Systeme sind mit Mechanismen zur menschlichen
        Aufsicht ausgestattet, darunter Inhaltsüberwachung, Sicherheitsfilter und die Möglichkeit,
        bestimmte Ergebnisse bei Bedarf einzuschränken oder zu deaktivieren.
      </p>
      <p>
        <strong>Verantwortung des Nutzers:</strong> Die Nutzer tragen die volle Verantwortung dafür, wie
        sie KI-generierte Inhalte interpretieren und nutzen. Der KI-Assistent sollte nicht für
        medizinische, rechtliche oder andere risikoreiche Entscheidungen verwendet werden.
      </p>
      <p>
        <strong>Sicherheits- und Überwachungsmaßnahmen für KI:</strong> Wir implementieren zusätzliche
        Sicherheitsvorkehrungen für KI-Systeme, darunter die Überwachung auf schädliche oder
        unangemessene Ergebnisse, Ratenbegrenzung, Inhaltsfilterung sowie die kontinuierliche Bewertung
        der Systemleistung und der Risiken.
      </p>

      <h2>16. Welche Rechte haben Sie?</h2>
      <p>Gemäß der DSGVO stehen Ihnen in Bezug auf Ihre personenbezogenen Daten eine Reihe von Rechten zu:</p>
      <ul>
        <li>
          <strong>Auskunftsrecht:</strong> Sie haben das Recht zu erfahren, ob wir Ihre Daten verarbeiten,
          und wenn ja, Informationen über die Verarbeitung sowie eine Kopie Ihrer Daten zu erhalten.
        </li>
        <li>
          <strong>Recht auf Berichtigung:</strong> Sie haben das Recht, die Berichtigung unrichtiger oder
          unvollständiger Daten (z.&nbsp;B. Name, Adresse) zu verlangen.
        </li>
        <li>
          <strong>Recht auf Löschung („Recht auf Vergessenwerden“):</strong> Sie können die Löschung
          Ihrer Daten verlangen, wenn diese für die Zwecke der Verarbeitung nicht mehr erforderlich sind
          oder wenn Sie Ihre Einwilligung widerrufen und keine andere Rechtsgrundlage vorliegt.
        </li>
        <li>
          <strong>Recht auf Datenübertragbarkeit:</strong> Sie haben das Recht, die von Ihnen bereitgestellten
          Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder deren
          Übermittlung an einen anderen Verantwortlichen zu verlangen.
        </li>
        <li>
          <strong>Recht auf Einschränkung der Verarbeitung:</strong> Das Recht, die Einschränkung der
          Verarbeitung zu beantragen, während Einwände oder Streitigkeiten geprüft werden.
        </li>
        <li>
          <strong>Widerspruchsrecht:</strong> Das Recht, der Verarbeitung aufgrund eines berechtigten
          Interesses zu widersprechen. Wir werden die Verarbeitung einstellen, es sei denn, wir können
          zwingende berechtigte Gründe nachweisen.
        </li>
        <li>
          <strong>Recht auf Widerruf der Einwilligung:</strong> Wenn die Verarbeitung auf Ihrer Einwilligung
          beruht, können Sie diese jederzeit mit Wirkung für die Zukunft widerrufen (z.&nbsp;B. für Newsletter,
          Marketingmitteilungen, Gesundheitsdaten des KI-Assistenten).
        </li>
        <li>
          <strong>Rechte im Zusammenhang mit der KI-Verarbeitung:</strong> Sie haben das Recht:
          <ul>
            <li>● darüber informiert zu werden, wenn Sie mit KI interagieren</li>
            <li>● gegebenenfalls menschliches Eingreifen zu verlangen</li>
            <li>● der Verarbeitung unter Einbeziehung von KI zu widersprechen, wenn diese Sie erheblich betrifft</li>
            <li>● Ihre Einwilligung zur KI-bezogenen Datenverarbeitung jederzeit zu widerrufen</li>
          </ul>
        </li>
        <li>
          <strong>
            Zusätzliche Rechte für Nutzer außerhalb des EWR (einschließlich der Vereinigten Staaten):
          </strong>{' '}
          Je nach Ihrem Standort stehen Ihnen gemäß den geltenden Gesetzen möglicherweise zusätzliche
          Rechte zu, darunter: Einwohner bestimmter US-Bundesstaaten (wie Kalifornien, Virginia, Colorado
          und andere) können diese Rechte ausüben, indem sie uns unter{' '}
          <a href="mailto:info@vivianlab.com">info@vivianlab.com</a> kontaktieren.
          <ul>
            <li>Das Recht zu erfahren, welche personenbezogenen Daten wir erheben und wie diese verwendet werden</li>
            <li>Das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen</li>
            <li>
              Das Recht, dem Verkauf oder der Weitergabe personenbezogener Daten zu widersprechen (wir
              verkaufen keine personenbezogenen Daten)
            </li>
            <li>Das Recht auf Nichtdiskriminierung bei der Ausübung Ihrer Rechte</li>
          </ul>
        </li>
      </ul>
      <p>
        <strong>Verzicht auf den Erhalt von Marketingmitteilungen.</strong> Sie können den Erhalt von
        Marketingmitteilungen ablehnen, indem Sie Ihre E-Mail- und SMS-Registrierungen ändern, auf den
        Abmeldelink klicken oder den Anweisungen in der Nachricht folgen, oder indem Sie uns kontaktieren.
      </p>

      <h2>17. Wie können Sie Ihre Rechte ausüben?</h2>
      <p>
        Um Ihre Rechte auszuüben, können Sie eine Anfrage an{' '}
        <a href="mailto:info@vivianlab.com">info@vivianlab.com</a> mit dem Betreff „Ausübung von Rechten“
        senden. Wir werden diese prüfen und so schnell wie möglich antworten.
      </p>
      <p>Ausnahmsweise:</p>
      <ul>
        <li>
          Wenn Sie Ihre Daten in Ihrem Benutzerkonto korrigieren möchten, können Sie sich anmelden und
          die Korrektur/Änderung direkt vornehmen.
        </li>
        <li>
          Wenn Sie Ihre Einwilligung zum Newsletter widerrufen möchten, können Sie dies über den
          Abmeldelink in jedem Newsletter tun.
        </li>
        <li>
          Wenn Sie keine Web-Push-Benachrichtigungen erhalten möchten, können Sie diese in Ihren
          Browsereinstellungen deaktivieren.
        </li>
      </ul>
      <p>
        Um die Vertraulichkeit Ihrer Daten zu schützen, bitten wir Sie möglicherweise, Ihre Identität zu
        bestätigen, bevor wir Ihrer Anfrage nachkommen. Wenn Sie einen Dritten bevollmächtigt haben, eine
        Anfrage in Ihrem Namen zu stellen, bitten wir diesen möglicherweise, einen Nachweis über diese
        Bevollmächtigung vorzulegen.
      </p>

      <h2>18. Wann antworten wir auf Ihre Anfragen?</h2>
      <p>
        Wir beantworten Ihre Anfragen kostenlos und unverzüglich, spätestens jedoch innerhalb eines (1)
        Monats nach Eingang Ihrer Anfrage. Sollte Ihre Anfrage komplex sein oder sollten wir eine große
        Anzahl von Anfragen erhalten haben, benötigen wir unter Umständen bis zu zwei (2) weitere Monate;
        in diesem Fall werden wir Sie innerhalb des ersten Monats darüber informieren.
      </p>

      <h2>19. Welches Recht gilt, wenn wir Ihre Daten verarbeiten?</h2>
      <p>
        Es gilt griechisches Recht in der Fassung der DSGVO sowie allgemein der aktuelle nationale und
        europäische Rechts- und Regulierungsrahmen für den Schutz personenbezogener Daten.
      </p>
      <p>
        Jede Streitigkeit, die sich aus dem Schutz Ihrer personenbezogenen Daten ergibt oder damit in
        Zusammenhang steht, unterliegt einem Schiedsverfahren gemäß der Mediationsordnung der
        Europäischen Mediations- und Schiedsgerichtsorganisation (EOMIA). Wird die Streitigkeit oder ein
        Teil davon nicht durch Mediation beigelegt, wird sie ausschließlich, endgültig und unwiderruflich
        durch ein Schiedsgericht gemäß der EODID-Schiedsgerichtsordnung entschieden.
      </p>
      <p>
        Im Falle von Streitigkeiten bezüglich des Vorstehenden sind die Gerichte der Stadt Athen zuständig.
      </p>

      <h2>
        20. Wohin können Sie sich wenden, wenn wir gegen das anwendbare Recht zum Schutz Ihrer
        personenbezogenen Daten verstoßen?
      </h2>
      <p>
        Sie haben das Recht, eine Beschwerde bei der Datenschutzbehörde einzureichen, wenn Sie der Ansicht
        sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die geltenden Rechts- und
        Verwaltungsvorschriften zum Schutz personenbezogener Daten verstößt:
      </p>
      <p>
        Griechische Datenschutzbehörde, Kifisias 1-3, 115 23, Athen, Griechenland, Tel.: +30 210 6475600,
        E-Mail: <a href="mailto:contact@dpa.gr">contact@dpa.gr</a>.
      </p>

      <h2>21. Wie werden Sie über Änderungen dieser Richtlinie informiert?</h2>
      <p>
        Wir aktualisieren diese Datenschutzerklärung bei Bedarf. Sollten sich wesentliche Änderungen an
        der Datenschutzerklärung oder an der Art und Weise, wie wir Ihre personenbezogenen Daten
        verwenden, ergeben, werden wir vor Inkrafttreten der Änderungen eine aktualisierte Fassung auf
        unserer Website veröffentlichen und Sie so schnell wie möglich darüber informieren.
      </p>
      <p>
        Wir empfehlen Ihnen, diese Erklärung regelmäßig zu lesen, um zu erfahren, wie Ihre Daten
        geschützt werden. Diese Datenschutzerklärung wurde zuletzt am 16. November 2023 geändert.
      </p>
      <p>
        Für weitere Informationen und Fragen, die sich aus dieser Datenschutzerklärung ergeben, stehen
        wir Ihnen gerne zur Verfügung. Bitte kontaktieren Sie uns unter{' '}
        <a href="mailto:info@vivianlab.com">info@vivianlab.com</a>.
      </p>
    </div>
  );
}

export default PrivacyGerman;
